import * as React from 'react';

import type { AdminActivationAlertsClient } from '@/api/admin-activation-alerts-client';
import { HttpAdminActivationAlertsClient } from '@/api/admin-activation-alerts-client.http';

// =============================================================================
// admin-activation-alerts-client-context.tsx — Injection du client (DI seam).
// =============================================================================
// Permet de substituer le client sans toucher l'UI. Par défaut : l'adaptateur HTTP RÉEL
// (HttpAdminActivationAlertsClient). Les tests de composant injectent le
// StubAdminActivationAlertsClient (double déterministe) via le provider.

/** Adaptateur par défaut : HTTP réel (chemins relatifs racine API, cookie de session admin). */
const defaultAdminActivationAlertsClient: AdminActivationAlertsClient =
  new HttpAdminActivationAlertsClient();

const AdminActivationAlertsClientContext =
  React.createContext<AdminActivationAlertsClient>(
    defaultAdminActivationAlertsClient,
  );

export interface AdminActivationAlertsClientProviderProps {
  client?: AdminActivationAlertsClient | undefined;
  children: React.ReactNode;
}

export function AdminActivationAlertsClientProvider({
  client = defaultAdminActivationAlertsClient,
  children,
}: AdminActivationAlertsClientProviderProps): React.JSX.Element {
  return (
    <AdminActivationAlertsClientContext.Provider value={client}>
      {children}
    </AdminActivationAlertsClientContext.Provider>
  );
}

export function useAdminActivationAlertsClient(): AdminActivationAlertsClient {
  return React.useContext(AdminActivationAlertsClientContext);
}
